import React from "react";
import {
  MenuItem,
  TextFieldProps,
  Select,
  withStyles,
  InputBase,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { ContainerSelectReccurence } from "domains/Request/component/shared/MainStyles";
import TextField from "./index";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiOutlinedInput-root": {
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px",
        borderBottomLeftRadius: "4px",
      },
      "& .MuiSelect-select.MuiSelect-select": {
        color: "white",
        textAlign: "center",
        backgroundColor: "#399EBF",
      },
      "& .MuiSelect-icon": {
        color: "white",
        top: "3px",
        width: "5vw",
        height: "6vh",
        right: "-17px"
      },
    },
    textField: { width: "175%" },
    select: { width: "30%" }
  })
);

const CustomInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
      color: "#FFF",
    },
    input: {
      textAlign: "center",
      borderTopLeftRadius: "0px",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
      borderBottomLeftRadius: "0px",
      position: "relative",
      backgroundColor: "#c4c4c4",
      fontSize: "16px",
      padding: "18.5px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderColor: "#c4c4c4",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "4px",
        borderBottomRightRadius: "4px",
        borderBottomLeftRadius: "0px",
        backgroundColor: "#c4c4c4",
      },
    },
  })
)(InputBase);

export interface ITextFieldwithOptionsItems {
  label: string;
  value: string;
}

interface ITextFieldwithOptions {
  options: Array<ITextFieldwithOptionsItems>;
  handleOptionChange: (reccurenceOption: string) => void;
  reccurenceOptionValue?: string;
  textFieldValue: any;
  errorOptionValue?: boolean;
  onChangeInputValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TextFieldwithOptions({
  options,
  handleOptionChange,
  textFieldValue,
  reccurenceOptionValue,
  errorOptionValue = false,
  onChangeInputValue,
  ...props
}: ITextFieldwithOptions & TextFieldProps) {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    handleOptionChange(event.target.value as string);
  };

  return (
    <ContainerSelectReccurence className={classes.root}>
      <TextField className={classes.textField} {...props} onChange={onChangeInputValue} value={textFieldValue} />
      <Select
        className={classes.select}
        name="optionTextField"
        labelId="demo-customized-select-label"
        id="optionTextField"
        input={<CustomInput />}
        value={reccurenceOptionValue || ""}
        onChange={handleChange}
      >
        {options?.map((reccurenceOption, index) => (
          <MenuItem value={reccurenceOption?.value} key={index}>
            {reccurenceOption?.label}
          </MenuItem>
        ))}
      </Select>
    </ContainerSelectReccurence>
  );
}
